import React, { useEffect, useRef, useState } from 'react'
import './activity-list.styles.scss'
import { format } from 'date-fns'
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const ActivityList = ({ 
    gameActivity, 
    playerList,
    gameManagers
}) => {
    
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ moreActivity, setMoreActivity ] = useState(false);
    const [ activityToDisplay, setActivityToDisplay ] = useState([]);
    const navigate = useNavigate();
    let start = 0
    const endRef = useRef(40);

    useEffect(() => {
        if (!gameActivity) {return;}
        // console.log(gameActivity);
        showActivity();
    }, [gameActivity])

    function showActivity() {
        let sortedActivity = Object.values(gameActivity).sort((a,b) => a.ts < b.ts ? 1 : -1)
        .filter(a => a.ts > 0);
        console.log(endRef.current);
        setActivityToDisplay(sortedActivity.slice(start, endRef.current));
        if (sortedActivity.length > endRef.current) {
            setMoreActivity(true);
        } else {
            setMoreActivity(false);
        }
    }

    function loadMoreActivity() {
        endRef.current += 20
        showActivity();
    }

    return (
        <div className={`activity-list ${screenSize}`}>
            {
                (gameManagers && activityToDisplay.length > 0 && playerList) &&
                activityToDisplay
                .map(a => {
                    let manager = gameManagers.find(m => m.appId === a.appId)
                    if (!manager) manager = {'fName': 'Unknown', 'lName': 'Manager'};
                    let playerData;
                    if (a.playerId) {
                        playerData = playerList[a.playerId];
                        if (!playerData) return null;
                    }
                    return (
                    <div 
                        key={a.id} 
                        className='activity-item'
                        title={format(new Date(a.ts), 'Pp')}
                        >
                        <div className='activity-icon'>
                            <ImageContainer src={a.icon} alt='activity icon' className='icon' />
                        </div>
                        <div className='activity-text'>
                            {
                                a.display === 'managerActivity'
                                ?
                                <div>
                                    <b>{a.title}</b>: {a.event} by <b>{manager.fName} {manager.lName}</b>
                                </div>
                                :
                                <div>
                                    <b>{a.title}</b>: {a.event} by <b>{a.userName ? a.userName : (playerData && playerData.displayName) ? playerData.displayName : ''}</b> on {format(new Date(a.ts), 'Pp')}
                                </div>
                            }
                            </div>
                        </div>
                    )
                })
            }
            <div className='more-button'>
                <button 
                    className='g-button small-btn' 
                    onClick={() => navigate('activity')}>
                    View more...
                </button>
            </div>
        </div>
    )
}

export default ActivityList